import React, { useEffect, useState } from 'react';

import { X } from 'phosphor-react';

import { CloseBtn, Container, ModalBanner, Poster } from './styles';

interface ModalDashboardBannerProps {
  imageUrl: string;
  redirectUrl?: string;
  dismissKey?: string;
}

const ModalDashboardBanner: React.FC<ModalDashboardBannerProps> = ({
  imageUrl,
  redirectUrl,
  dismissKey = 'dashboard_banner_dismissed',
}) => {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    // Verifica se o banner foi marcado como não visualizar novamente
    const isDismissed = localStorage.getItem(dismissKey);

    if (!isDismissed) {
      setOpenModal(true);
    }
  }, [dismissKey]);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleDismiss = () => {
    localStorage.setItem(dismissKey, 'true');
    handleClose();
  };

  const handleImageClick = () => {
    if (redirectUrl) {
      window.open(redirectUrl, '_blank');
    }
  };

  return (
    <Container>
      <ModalBanner
        onRequestClose={handleClose}
        isOpen={openModal}
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        closeTimeoutMS={300}
        overlayClassName="react-modal-overlay"
      >
        <Poster>
          <CloseBtn onClick={handleClose}>
            <X weight="bold" />
          </CloseBtn>

          <img
            src={imageUrl}
            alt="Dashboard Banner"
            onClick={handleImageClick}
            style={{ cursor: redirectUrl ? 'pointer' : 'default' }}
          />

          <div>
            <input
              type="checkbox"
              id="dismiss-banner"
              onChange={e => {
                if (e.target.checked) {
                  handleDismiss();
                }
              }}
            />
            <label htmlFor="dismiss-banner"> Não mostrar novamente</label>
          </div>
        </Poster>
      </ModalBanner>
    </Container>
  );
};

export default ModalDashboardBanner;
